import actionTypes from '../constants/action-types';

const setFocusedElement = (elementId) => ({
  type: actionTypes.SET_FOCUSED_ELEMENT,
  payload: {
    elementId,
  },
});

export default setFocusedElement;
